import React from 'react';
import Logo from '../assets/Logo.png';

const LoadingSpinner: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'var(--bg-base)',
      gap: '24px',
    }}>
      <img src={Logo} alt="Elola Technologies" style={{ width: '64px', height: '64px', objectFit: 'contain', opacity: 0.9 }} />
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '3px solid rgba(109, 74, 255, 0.15)',
        borderTopColor: 'var(--accent-purple)',
        animation: 'spin-ring 0.8s linear infinite',
      }} />
    </div>
  );
};

export default LoadingSpinner;
